export default {
  common: {
    // Navigation
    nav: {
      home: "Home",
      aboutUs: "About Us",
      ourMission: "Our Mission",
      blog: "Blog",
      logIn: "Log In",
      signUp: "Sign Up",
      yourAccount: "Your Account",
      logOut: "Log Out",
      services: "Services",
      spaces: "Spaces",
      faq: "FAQ",
      termsConditions: "Terms and Conditions",
      privacyPolicy: "Privacy Policy",
      cookiesPolicy: "Cookies Policy",
    },

    // Actions
    actions: {
      submit: "Submit",
      showPassword: "Show password",
      hidePassword: "Hide password",
      discoverMore: "Discover more",
      learnMore: "Learn more",
      tryAgain: "Try again later, ",
      contactSupport: "If the problem persists, please contact our",
      support: "support",
    },

    // Status Messages
    status: {
      success: "Success!",
      error: "Error!",
      loading: "Loading...",
      redirecting: "Redirecting in {countdown} seconds...",
      invalidToken: "Invalid token",
      requiredField: "This field is required",
      verificationFailed: "Verification failed",
    },

    // Form Labels
    form: {
      email: "E-mail",
      password: "Password",
      companyName: "Company Name",
      telephone: "Telephone",
      website: "Website Address",
      country: "Country",
      vat: "VAT/Tax ID",
      newPassword: "New Password",
      confirmPassword: "Confirm Password",
      titles: {
        website: 'Please, enter a "https://" website',
      },
      placeholders: {
        companyName: "Enter company name",
        email: "Enter email",
        telephone: "Enter phone",
        website: "https://website.com",
        vat: "Company's VAT number (or equivalent)",
        password: "Enter complex password",
      },
    },

    // Validation Messages
    validation: {
      emailInvalid: "Please enter a valid email",
      websiteRequirements: 'You must provide a secure "https://" url',
      passwordRequirements:
        "At least 12 characters, 1 uppercase, 1 lowercase, 1 digit and 1 special symbol",
      passwordMismatch: "Passwords do not match",
      passwordLength: "Password must contain at least 12 characters",
      passwordSymbol: "Must contain at least one special symbol",
      passwordUppercase: "Must contain at least one uppercase letter",
      passwordLowercase: "Must contain at least one lowercase letter",
      passwordNumber: "Must contain at least one number",
    },

    // Company Info
    company: {
      name: "Biglo",
      logoAlt: "Biglo Logo",
      copyright: "Copyright © {year} Biglo Solutions",
      supportEmail: "biglodevelop@gmail.com",
    },

    // Social Media
    social: {
      followUs: "Follow Us",
      linkedIn: "LinkedIn",
      youtube: "YouTube",
    },

    // Miscellaneous
    or: " or ",
    yes: "Yes",
    no: "No",
    ifNotRedirected: "If not redirected, you can go to",
  },

  header: {
    goToHomepage: "Go to homepage",
    bigloLogo: "Biglo Logo",
    toggleMenu: "Toggle navigation menu",
    mainNavigation: "Navigation Links",
    registerSpaceService: "Register space/service",
    account: "Account",
  },

  hero: {
    title: "OPTIMIZE YOUR SPACE AND IMPROVE YOUR LOGISTICS",
    subtitle:
      "Tailored storage solutions designed to meet your business needs.",
    cta: "Sign up Now",
    ctaAriaLabel: "Sign up now to optimize your logistics",
    imageAlt: "Warehouse image",
  },

  landing: {
    logisticsImageAlt: "Logistics concept",
    logisticsTitle: "NEED TO BOOST YOUR LOGISTICS?",
    logisticsDescription:
      "Find the logistics provider that best suits your needs and cut your logistics costs",
    logisticsCtaText: "Check our Directory",
    warehouseImageAlt: "Warehouse interior",
    warehouseTitle: "LOOKING FOR A LOGISTICS WAREHOUSE?",
    warehouseDescription:
      "Access the largest platform of logistics facilities and find the perfect warehouse for your business.",
    warehouseCtaText: "Spaces Searcher",
  },

  mission: {
    title: "CONNECTING COMPANIES, OPTIMIZING LOGISTICS AND REDUCING COSTS",
    description:
      "Reserve your space and unlock access to our entire network of logistics providers and partner companies.",
    ctaText: "Biglo's Mission",
    ctaAriaLabel: "Learn more about Biglo's mission",
  },

  clients: {
    trustedBy: "TRUSTED BY LEADING COMPANIES",
    companyLogo: "{company} Logo",
  },

  blog: {
    latestArticles: "LATEST ARTICLES",
    articleImageAlt: "Illustration for article: {title}",
    discoverMoreAriaLabel: "Discover more blog articles",
    categories: {
      trends: "Trends",
      guides: "Guides",
    },
    articles: {
      trends2024: {
        title: "Logistics Trends 2024: Prepare Your Business for the Future",
      },
      chooseProvider: {
        title: "How to Choose the Right Logistics Provider for Your Business",
      },
    },
  },

  footer: {
    ourPartners: "Our Partners",
    resources: "Resources",
  },

  login: {
    title: "User Login",
    emailPlaceholder: "Enter your email",
    passwordPlaceholder: "Enter your password",
    forgotPassword: "Forgot your password?",
    submit: "Log In",
    error: "An error occurred during login.",
  },

  cookiesDisclaimer: {
    title: "Your Privacy, Our Priority",
    message: {
      preCompany: "At",
      company: " Biglo",
      postCompany:
        ", we deeply respect your privacy. We use only essential cookies to keep our platform secure — nothing more.",
    },
    noTracking: "We never track, analyze, or sell your data",
    learnMore: {
      preLink: ". Learn more in our ",
      link: "Cookies' Policy",
      postLink: ".",
    },
    understood: "Understood",
    policy: "Cookies' Policy",
  },

  account: {
    aside: {
      greeting: "Welcome back, ",
      guest: "Guest",
      buttons: {
        UserDetails: "User Details",
        MessageCenter: "Message Center",
        MyFavourites: "My Favourites",
        SavedSearches: "Saved Searches",
        SpacesManagement: "Spaces Management",
        ServicesManagement: "Services Management",
      },
    },
  },

  userDetails: {
    title: "User Details",
    loading: "Loading user data...",
    logo: "Logo",
    name: "Name",
    email: "Email",
    telephone: "Telephone",
    website: "Website",
    country: "Country",
    newPassword: "New Password",
    currentPassword: "Current Password",
    saveChanges: "Save Changes",
    togglePassword: "Toggle password visibility",
    placeholders: {
      name: "Name",
      email: "Email",
      telephone: "Telephone number",
      website: "Website",
      country: "Country",
    },
  },

  search: {
    filters: {
      heading: "Filters",
      location: {
        legend: "Location",
        internationalCoverage: "International Coverage",
        typeSelector: {
          label: "Filter by",
          country: "Country",
          region: "Region",
          city: "City",
          continents: "Continents",
        },
        countryInput: {
          label: "Search country",
          placeholder: "Enter the country",
        },
        regionInput: {
          label: "Enter a region",
          placeholder: "Enter a region",
        },
        cityInput: {
          label: "Enter a city",
          placeholder: "Enter a city",
        },
        continentsLabel: "Select continents",
        options: {
          europe: "Europe",
          northAmerica: "North America",
          asia: "Asia",
          southAmerica: "South America",
          oceania: "Oceania",
          africa: "Africa",
        },
      },
      plType: {
        legend: "Type of PL",
        label: "Select PL types",
        options: {
          pl2: "2PL",
          pl3: "3PL",
          pl4: "4PL",
          pl5: "5PL",
        },
      },
      transportation: {
        legend: "Transportation",
        label: "Select transportation options",
        options: {
          aerialTransportation: "Aerial",
          groundTransportation: "Ground",
          maritimeTransportation: "Maritime",
          lastMile: "Last Mile",
          multimodalTransportation: "Multimodal",
        },
      },
      storage: {
        legend: "Storage Options",
        label: "Select storage options",
        options: {
          dry: "Dry",
          refrigerated: "Refrigerated",
          freezer: "Freezer",
          dangerousGoods: "Dangerous Goods",
        },
      },
      industry: {
        legend: "Sector/Industry",
        label: "Select industry sectors",
        options: {
          retail: "Retail",
          foodsAndDrinks: "Foods & Drinks",
          pharma: "Pharma",
          automotive: "Automotive",
          technology: "Technology",
          clothes: "Clothes",
        },
      },
      contract: {
        legend: "Contract Options",
        label: "Select contract options",
        options: {
          shortTermOperations: "Short-Term",
          longTermOperations: "Long-Term",
          ocasionalOperations: "Occasional",
        },
      },
      ordersManagement: {
        legend: "Orders Management Options",
        label: "Select orders management options",
        options: {
          picking: "Picking",
          packing: "Packing",
          labeling: "Labeling",
        },
      },
      applyButton: "Apply Filters",
    },
    results: {
      title: "Service Results",
      servicesFound: "{count} service found | {count} services found",
      loading: "Loading...",
      toggleView: "Toggle View List/Grid",
      imageAlt: "Image for {name}'s service",
      defaultImageAlt: "Default service icon",
      surface: "Surface",
      palletPositions: "Pallet Positions",
      height: "Height",
      transportation: "Transportation",
      storage: "Storage",
      noResults: "No services found. Try adjusting your search filters.",
    },
    details: {
      imageAlt: "Service image",
      description: "Description",
      noDescription: "No description available",
      address: "Address",
      logisticsInfo: "Logistics Information",
      internationalCoverage: "International Coverage",
      plTypes: "PL Types",
      dimensions: "Dimensions",
      transportation: "Transportation",
      storage: "Storage",
      contactOwner: "Contact owner",
    },
    toggleFilters: "Toggle filters",
  },

  register: {
    title: "User Registry",
    logo: {
      label: "Logo",
      optional: "(Not required, you can upload it later)",
    },
    submit: "Register",
    notifications: {
      success: "Registration successful!\nCheck email to verify your account.",
      error: "An error occurred during registration.",
    },
  },

  verifyUser: {
    title: "User Verification",
    success: "Your account has been successfully verified!",
    successNotification: "Email successfully verified!",
    verifying: "Verifying your email...",
    errorPrefix: "{status}:",
    errors: {
      expired: "Verification link has expired.",
      invalid: "Enlace de verificación inválido.",
      alreadyVerified: "Este email ya está verificado.",
    },
  },

  passwordForgotten: {
    title: "Password Forgotten",
    instructions:
      "Enter your email below, and we'll send you a link to reset your password.",
    emailTitle: "Please, enter a valid email. No '+' allowed.",
    submitButton: "Send Reset Email",
    buttonLabel: "Submit email for password reset button",
    success: "Password reset email sent successfully",
    error: "An error occurred. Please try again.",
  },

  passwordReset: {
    title: "Reset Password",
    placeholder: "Enter new password",
    placeholder2: "Confirm new password",
    success: "Your password has been reset successfully!",
    formErrors: "Please correct the errors in the form.",
    validation: {
      length: "{validation.passwordLength}",
      symbol: "{validation.passwordSymbol}",
      uppercase: "{validation.passwordUppercase}",
      lowercase: "{validation.passwordLowercase}",
      number: "{validation.passwordNumber}",
      match: "{validation.passwordMismatch}",
    },
    links: {
      login: "log-in",
      account: "your-account",
      home: "return home",
      support: "support",
    },
    submit: "Change Password",
  },
  ourMission: {
    hero: {
      title: "Biglo: Connecting Logistics Ecosystems",
      subtitle:
        "The 360° platform bridging logistics operators, space providers and seekers through secure, ethical technology",
    },
    sections: {
      revolution: {
        title: "Revolutionizing Logistics Connections",
        items: [
          {
            title: "For Logistics Partners & Space Owners",
            description: [
              "Maximize your assets' potential through our secure network of verified seekers.",
              "Whether you manage fleets or own logistics facilities, connect with quality partners that align with your operational standards and business needs.",
            ],
          },
          {
            title: "For Logistics Seekers & Solution Finders",
            description: [
              "Find tailored solutions through our verified network of operators and facilities.",
              "Access real-time availability, transparent pricing and compliance guarantees. Ensure efficiency and reliability with partners that meet your logistics demands.",
            ],
          },
        ],
      },
      integrity: {
        title: "Built on Integrity",
        items: [
          {
            title: "Sector Collaboration",
            description:
              "Creating symbiotic relationships that elevate entire supply chains.",
          },
          {
            title: "Privacy First",
            description:
              "Collecting only essential data - never sold or shared",
          },
          {
            title: "Operational Excellence",
            description: "AI-powered matching for optimal resource allocation",
          },
        ],
      },
      security: {
        title: "Enterprise-Grade Security",
        items: [
          {
            title: "Zero Third-Party Cookies",
            description: "We respect your digital footprint and privacy",
          },
          {
            title: "Military-Grade Encryption",
            description: "JWT tokens, CSRF protection, and secure data hashing",
          },
          {
            title: "Data Minimalism",
            description: "We only store strictly essential information",
          },
        ],
      },
      advantages: {
        title: "Biglo's 360° Advantage",
        items: [
          {
            title: "Operators",
            description: "Optimize fleet utilization with smart matching",
          },
          {
            title: "Space Owners",
            description: "Transform dormant assets into revenue streams",
          },
          {
            title: "Seekers",
            description: "Instant access to vetted logistics solutions",
          },
        ],
      },
      cta: {
        title: "Strengthen the Logistics Chain",
        content:
          "Join professionals elevating the industry through secure collaboration",
        authenticatedButton: "Register your service/space!",
        guestButton: "Register your business!",
      },
    },
  },

  meta: {
    default: {
      title: "Biglo - B2B Logistics Platform",
      description:
        "The leading B2B platform connecting logistics operators, warehouse owners and space seekers.",
      image: "https://biglosolutions.com/images/biglo_logo.png",
      url: "https://biglosolutions.com",
    },
  },
};
